// extracted by mini-css-extract-plugin
module.exports = {"blockMobileMenuSupport":"mobile-menu-support_blockMobileMenuSupport__1uAT7","text":"mobile-menu-support_text__1FnAr"};